import { isAnEditRegex, negativeMatchRegex, startsWithPunctuationRegex } from '../components/proofreaderActivities/sharedRegexes'

export const joinWords = (wordArray: string[], render: (word: string, index: number) => string = word => word) => {
  let paragraphString = ''
  wordArray.forEach((word: string, i: number) => {
    paragraphString += render(word, i)

    const nextWord = wordArray[i + 1]
    if (!nextWord) { return }

    const nextWordIsAnEdit = nextWord.match(isAnEditRegex)

    if (nextWordIsAnEdit) {
      const negativeMatch = nextWord.match(negativeMatchRegex)
      if (negativeMatch && negativeMatch[1].match(startsWithPunctuationRegex)) { return }
    } else if (nextWord.match(startsWithPunctuationRegex)) {
      return
    }

    paragraphString += ' '
  })
  return paragraphString
}
